<template>
  <div class="applyinfo">
    <div class="tit">基本信息</div>
    <div class="mainBox">
      <div class="tip">
        <!-- 对应申请列表的审核状态1审核中 2已通过(不显示) 4已驳回 5申请下架 -->
        <Alert
          type="error"
          show-icon
          style="color: rgb(237, 64, 20)"
          v-if="applyDetails.status == 4"
        >
          已驳回
          <span class="tipRight_ lineBreak">原因：{{ applyDetails.rejectCause || 暂无原因 }}</span>
        </Alert>
      </div>
      <div class="main">
        <div class="main-left">
          <div class="main-left-item">
            <div>服务使用类型：</div>
            <div>{{ getKforV(serveUseList, applyDetails.serviceUsedType) }}</div>
          </div>
          <div class="main-left-item" v-if="applyDetails.serviceUsedType != 1">
            <div>事件推送类型：</div>
            <div>{{ getKforV(eventList, applyDetails.eventPushType) }}</div>
          </div>
          <div class="main-left-item">
            <div>参数类型：</div>
            <div>{{ getKforV(serveTypeList, applyDetails.serviceType) }}</div>
          </div>
          <div class="main-left-item">
            <div>服务场景：</div>
            <div>
              <span v-for="(item, index) in applyDetails.serviceScenes" :key="index">
                {{ item.sceneTypeName }}-{{ item.sceneServiceTypeName }}
                <span
                  v-if="index < applyDetails.serviceScenes.length - 1"
                >、</span>
              </span>
            </div>
          </div>
          <div class="main-left-item">
            <div>服务名称：</div>
            <div>{{ applyDetails.name }}</div>
          </div>
          <div class="main-left-item">
            <div>服务简介：</div>
            <div class="desWid">{{ applyDetails.introduce }}</div>
          </div>
          <div class="main-left-item">
            <div>服务主图：</div>
            <div class="mainImg">
              <img :src="applyDetails.imgUrl" alt />
            </div>
          </div>
          <div class="main-left-item">
            <div>服务介绍：</div>
            <div v-html="applyDetails.serviceIntroduce" class="editType"></div>
          </div>
          <div class="main-left-item">
            <div>实例：</div>
            <div>{{ applyDetails.modelName || "暂无数据" }}</div>
          </div>
          <div class="main-left-item">
            <div>版本：</div>
            <div>{{ version}}</div>
          </div>
          <div class="main-left-item">
            <div>版本说明：</div>
            <div class="lineBreak">{{ versionDesc }}</div>
          </div>
          <!-- <div class="main-left-item">
            <div>分析源类型：</div>
            <div>{{ applyDetails.sourceType }}</div>
          </div>-->
          <div class="main-left-item">
            <div>技术规格：</div>
            <div style="min-width: 850px; flex-grow: 1">
              <specifications :showInput="false" :technologyForm="technologyForm"></specifications>
            </div>
          </div>
          <div class="titServe" v-if="applyDetails.status == 5">下架原因</div>
          <!-- <div
            class="titServe"
            v-if="applyDetails.status==4"
          >驳回原因</div>
          <div v-if="applyDetails.status==4">{{ applyDetails.rejectCause || '暂无原因' }}</div>-->
          <div
            v-if="applyDetails.status == 5"
            class="lineBreak"
          >{{ applyDetails.offShelfCause || "暂无原因" }}</div>
          <div class="main-left-item">
            <p class="returnBtn">
              <!-- 审核通过 -->
              <Poptip
                class="poptip"
                confirm
                transfer
                placement="top"
                @on-ok="checkPass"
                @on-cancel="cancelCheckPass"
                title="确认通过审核吗？"
              >
                <Button class="btn1" type="primary" v-if="applyDetails.status != 4">审核通过</Button>
              </Poptip>
              <!-- 审核驳回 -->
              <Button class="btn2" type="error" v-if="applyDetails.status != 4" @click="seeEdit">驳回</Button>
              <Button class="btn" @click="link('/serve/servechecklist')">返回</Button>
            </p>
          </div>
        </div>
        <!-- 提交记录状态4为驳回 -->
        <div class="main-right">
          <div class="top"></div>
          <div class="commitlist">
            <div class="commititem mb-16" v-for="(item, index) in historyList" :key="index">
              <div class="flexsb">
                <div>
                  <p v-if="item.status != 4">第{{ item.submitMsg }}次提交</p>
                  <p v-if="item.status == 4">已驳回</p>
                  <p class="mt-4">{{ item.createTime || "暂无" }}</p>
                </div>
                <div>
                  <img src="@/assets/img/video/commit_item.png" alt />
                </div>
              </div>
              <div
                v-if="item.status == 4"
                class="reason mt-16 pt-16 lineBreak"
              >原因：{{ item.rejectCause || "无原因" }}</div>
            </div>
          </div>
        </div>
        <!-- 驳回原因 -->
        <applyDown
          v-if="showEdit"
          @close="showEdit = false"
          @confirm="showEdit = false"
          :form="propForm"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {
  serevCheckDetail,
  checkPassUp,
  checkPassDown,
  getApplyVersion,
  getVersion
} from "@/api/service";
import { getDict } from "@/api/dict";
import specifications from "@/components/card/specifications.vue";
import applyDown from "../components/ApplyDown";

export default {
  name: "",
  components: { applyDown, specifications },
  data() {
    return {
      technologyForm: {},
      applyDetailId: "", //获取申请详情的ID
      applyDetails: "",
      historyList: "",
      serveTypeList: [],
      propForm: {},
      showEdit: false,
      sceneList: [], //服务场景列表
      serveUseList: [],
      eventList: [],
      version: "",
      versionDesc: ""
    };
  },
  created() {
    this.applyDetailId = this.$route.query.id;
    this.getServeList(); //获取参数类型
    this.getEventPushType(); //获取事件推送类型
    this.getServeUseType(); //获取服务使用类型
    this.getDetail(); //获取服务详情
    this.getApplyVersion();
  },
  mounted() {},
  destroyed() {},
  methods: {
    getApplyVersion() {
      getApplyVersion(this.applyDetailId).then(res => {
        let length = res.data.data.length;
        (this.version = length ? res.data.data[length - 1].version : "-/-"),
          (this.versionDesc = length
            ? res.data.data[length - 1].versionDesc
            : "-/-");
      });
    },
    link(path) {
      this.$router.push({ path: path });
    },
    //获取服务使用类型
    getServeUseType() {
      getDict("SERVICE_USED_TYPE").then(res => {
        if (res.data.code == 0) {
          let json = res.data.data;
          this.serveUseList = json;
        }
      });
    },
    //获取事件推送类型
    getEventPushType() {
      getDict("EVENT_PUSH_TYPE").then(res => {
        if (res.data.code == 0) {
          let json = res.data.data;
          this.eventList = json;
        }
      });
    },
    getScenceList() {
      getDict("SERVICE_SCENE").then(res => {
        if (res.data.code == 0) {
          let json = res.data.data;
          this.sceneList = json;
        } else {
          console.log("请求数据失败");
        }
      });
    },
    //获取详情
    getDetail() {
      console.log("id", this.applyDetailId);
      serevCheckDetail(this.applyDetailId)
        .then(res => {
          let json = res.data.data.socServiceApply;
          this.technologyForm = {
            chipRatio: json.chipRatio ? json.chipRatio + "%" : "-/-",
            images: json.images || "-/-",
            qps: json.qps || "-/-",
            ram: json.ram || "-/-",
            vom: json.vom || "-/-",
            maxRoad: json.maxRoad || "-/-",
            disk: json.disk || "-/-",
            aimMinPixel: json.aimMinPixel || "-/-",
            serviceUseWay: json.serviceUseWay || "-/-",
            videoFramerate: json.videoFramerate || "-/-",
            resultShowWay: json.resultShowWay || "-/-"
          };

          console.log(res.data.data.socServiceApply);
          if (res.data.data.socServiceApply.sourceType) {
            res.data.data.socServiceApply.sourceType = res.data.data.socServiceApply.sourceType.replace(
              "0",
              "图片"
            );
            res.data.data.socServiceApply.sourceType = res.data.data.socServiceApply.sourceType.replace(
              "1",
              "视频"
            );
          } else {
            res.data.data.socServiceApply.sourceType = "-/-";
          }

          console.log(res.data.data.socServiceApply);
          this.applyDetails = res.data.data.socServiceApply;
          this.historyList = res.data.data.history;
          console.log("申请的详情", this.applyDetails, res.data.data);
        })
        .catch(err => {
          console.log(err, "err");
        });
    },
    //驳回操作
    seeEdit() {
      this.propForm = {
        id: this.applyDetailId,
        status: this.applyDetails.status
      };
      this.showEdit = true;
    },
    //取消通过
    cancelCheckPass() {
      console.log("点击了取消按钮--审核");
    },
    // 取消驳回
    cancelCheckRetun() {
      console.log("点击了取消按钮--驳回");
    },
    //审核通过
    checkPass() {
      // 上架审核通过
      if (this.applyDetails.status == 1) {
        checkPassUp(this.applyDetailId)
          .then(res => {
            console.log("res", res);
            console.log("res", res);
            this.$Message.success("上架审核通过");
            this.$router.push({ path: "/serve/servechecklist" });
          })
          .catch(err => {
            console.log(err, "err");
          });
      }
      // 下架审核通过
      if (this.applyDetails.status == 5) {
        checkPassDown(this.applyDetailId)
          .then(res => {
            console.log("res", res);
            console.log("res", res);
            console.log("==================");
            this.$Message.success("下架审核通过");
            this.$router.push({ path: "/serve/servechecklist" });
          })
          .catch(err => {
            console.log(err, "err");
          });
      }
    },

    // 服务类型（字典）
    getServeList() {
      getDict("SERVICE_TYPE").then(res => {
        if (res.data.code == 0) {
          let json = res.data.data;
          json.forEach(item => {
            item.name = item.k;
            item.id = item.v;
            item.active = false;
          });
          this.serveTypeList = json;
        } else {
          console.log("请求数据失败");
        }
      });
    },
    // 将服务类型id转换为对应的名称
    getKforV(list, state) {
      for (let k = 0; k < list.length; k++) {
        const element = list[k];
        if (element.v == state) return element.k;
      }
    }
  }
};
</script>

<style lang="scss">
.applyinfo {
  width: 100%;
  height: 100%;
  background: #ffffff;
  box-shadow: 0px 2px 10px 0px rgba(186, 187, 189, 0.05);
  border-radius: 8px;
  padding: 26px 32px;
  min-width: 1230px;
  .tit {
    font-size: 16px;
    font-family: MicrosoftYaHeiSemibold;
    color: #2f4061;
    font-weight: bold;
    width: 100%;
    padding-bottom: 16px;
    border-bottom: 1px solid #ebedf0;
    margin-bottom: 20px;
  }
  .mainBox {
    overflow-y: auto;
    height: calc(100% - 50px);
    .tip {
      .ivu-alert {
        color: rgb(140, 230, 176);
      }
      .tipRight {
        margin-left: 30px;
      }
      .tipRight_ {
        margin-left: 30px;
        color: rgb(237, 64, 20);
      }
    }
    .main {
      display: flex;
      justify-content: space-between;
      height: 100%;
      &-left {
        width: 60%;
        height: 100%;
        &-item {
          display: flex;
          margin-top: 18px;
          font-size: 14px;
          font-family: MicrosoftYaHei;
          color: #2f4061;
          > div:nth-of-type(1) {
            width: 130px;
            text-align: right;
            color: #67799c;
            flex-shrink: 0;
          }
          .editType {
            width: 70%;
            height: 100%;
            font-size: 14px;
            font-family: MicrosoftYaHei;
            color: #2f4061;
            p {
              word-break: break-word;
              img {
                width: 100%;
              }
            }
          }
          .returnBtn {
            display: flex;
            justify-content: center;
            padding-left: 90px;
            .btn {
              width: 104px;
              height: 36px;
              background: #ffffff;
              border-radius: 18px;
              border: 1px solid #dcdfe6;
              margin-left: 20px;
            }
            .btn1,
            .btn2 {
              width: 104px;
              height: 36px;
              border-radius: 18px;
            }
            .btn2 {
              margin-left: 20px;
            }
          }
          .desWid {
            width: 100%;
            .editorCont {
              width: 200px;
            }
          }
          .mainImg {
            width: 195px;
            height: 109px;
            border-radius: 8px;
            img {
              width: 195px;
              height: 109px;
              border-radius: 4px;
            }
          }
          .video {
            border-radius: 8px;
          }
          .video:focus {
            outline: none;
          }
        }
        .titServe {
          margin-top: 20px;
          font-size: 16px;
          font-family: MicrosoftYaHeiSemibold;
          color: #2f4061;
          font-weight: bold;
          width: 166%;
          padding-bottom: 16px;
          border-bottom: 1px solid #ebedf0;
          margin-bottom: 20px;
        }
      }
      &-right {
        width: 364px;
        overflow: auto;
        min-height: 100%;
        background: #ffffff;
        border-radius: 4px;
        margin-right: 20px;
        border: 1px solid #dcdfe6;
        > .top {
          height: 118px;
          display: flex;
          align-items: center;
          padding: 24px;
          background-image: url("~@/assets/img/video/commit_img.png");
          background-repeat: no-repeat;
          background-size: 100%;
          border-bottom: 1px solid #dcdfe6;
          .line {
            width: 32px;
            height: 2px;
            background: #3c8aff;
          }
        }
        > .commitlist {
          padding: 16px 24px;
          height: calc(100% - 118px);
          overflow: auto;
          .commititem {
            width: 100%;
            padding: 12px 24px;
            background: rgba(220, 223, 230, 0.1);
            border: 1px dashed #dcdfe6;
            border-radius: 4px;
            .reason {
              border-top: 1px solid rgba(246, 247, 249, 1);
            }
          }
        }
        > .commitlist div:last-child {
          margin-bottom: 0px;
        }
      }
    }
  }
}
</style>
